import { useState, useEffect } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from '../config/firebase';
import { DeviceUpdate } from '../types';
import { parseUpdateStatus } from '../utils/updates';


interface AllUpdatesState {
  updates: DeviceUpdate[];
  loading: boolean;
  error: string | null;
}

export function useAllUpdates(isAuthenticated: boolean = false): AllUpdatesState {
  const [updates, setUpdates] = useState<DeviceUpdate[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!isAuthenticated) {
      setLoading(true);
      return () => {};
    }

    const updatesRef = ref(database, 'updates');
    const unsubscribe = onValue(updatesRef, (snapshot) => {
      try {
        if (!snapshot.exists()) {
          setUpdates([]);
          setLoading(false);
          return;
        }

        const data = snapshot.val();
        if (typeof data !== 'object' || data === null) {
          setUpdates([]);
          setLoading(false);
          return;
        }

        const list: DeviceUpdate[] = Object.entries(data)
          .map(([key, value]: [string, any]) => ({
            id: key,
            apkUrl: value.apkUrl || '',
            deviceId: value.deviceId || '',
            status: parseUpdateStatus(value.status),
            createdAt: Number(value.createdAt) || 0,
            updatedAt: Number(value.updatedAt) || 0,
            updateType: value.updateType,
            errorMessage: value.errorMessage || undefined,
            errorTimestamp: value.errorTimestamp ? Number(value.errorTimestamp) : undefined
          }))
          .sort((a, b) => b.createdAt - a.createdAt);

        setUpdates(list);
        setLoading(false);
      } catch (err) {
        console.error('Erro ao processar updates:', err);
        setError(err instanceof Error ? err.message : 'Erro desconhecido');
        setLoading(false);
      }
    }, (err) => {
      setError(err instanceof Error ? err.message : 'Erro desconhecido');
      setLoading(false);
    });

    return () => unsubscribe();
  }, [isAuthenticated]);

  return { updates, loading, error };
}
